<template>
  <div class="topDiv">
    <el-row class="company" :gutter="20">
      <el-col :span="6">
        <img class="img" src="../assets/pcImage/company_default_logo.png" alt />
      </el-col>
      <el-col :span="10">
        <el-row class="companyName"
          ><span>{{
            item.comAbbreviation == null ? item.comName : item.comAbbreviation
          }}</span></el-row
        >
        <el-row class="xingzhi"
          ><span>{{ item.comIndustry }}</span></el-row>
      </el-col>
      <el-col :span="8">
        <img class="star" src="../assets/pcImage/selected_star.png" alt />
        <img class="star" src="../assets/pcImage/selected_star.png" alt />
        <img class="star" src="../assets/pcImage/selected_star.png" alt />
        <img class="star" src="../assets/pcImage/selected_star.png" alt />
        <img class="star" src="../assets/pcImage/selected_star.png" alt />
      </el-col>
    </el-row>
    <el-row style="padding: 10px 20px">
      <div class="flex-space-betw">
        <span class="hotlbl">热招：{{ item.cpPositionName }}</span>
        <span class="money"
          >{{ item.cpMinSalary.replace(">", "") }}-{{
            item.cpMaxSalary.replace(">", "")
          }}</span
        >
      </div>
      
      <div>
        <div class="bodybreak">
          <span>学历：{{item.cpEducationLabel}}</span>
        </div>
        <!-- <div class="flex-start">
          <div class="area" v-for="i in item.cpDamagedArea.split(',')">
            <span>maya</span>
          </div>
        </div> -->
      </div>
    </el-row>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
};
</script>
<style lang="stylus" scoped>
.flex-start {
  display: flex;
  // justify-content space-between;
  flex-wrap: wrap;
  padding-top: 3px;
}

.flex-space-betw {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topDiv {
  margin-top: 17px;
  width: 322px;
  height: 160px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  background-color: #fff;

  &:hover {
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
  }

  cursor: pointer;
  border-radius: 6px;

  .img {
    width: 60px;
    height: 60px;
  }

  .star {
    width: 13px;
    height: 12px;
  }

  .company {
    // margin-top: 18px;
    padding: 16px 16px;
    border-top: 1px dotted #f2f2f2;
    border-bottom: 1px dotted #f2f2f2;
  }

  .companyName {
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    color: #f72b17;
    line-height: 24px;
  }

  .area {
    display: inline;
    border: 1px solid #f2f2f2;
    margin-right: 10px;
    border-radius: 4px;
    padding: 0px 4px;
    margin-top: 5px;
    color: #9E9E9E;
  }

  .xingzhi {
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    color: #C2C2C2;
    line-height: 30px;
    width :200px;
  }

  .hotlbl {
    font-size: 14px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 21px;
  }

  .hotJob {
    display: inline-block;
    font-size: 12px;
    font-weight: 500;
  }

  .bodybreak {
    font-size: 12px;
    font-weight: 400;
    color: #9E9E9E;
    // line-height: 18px;
    // margin-left: 20px;
    display: block;
    text-align: left;
  }

  .money {
    font-size: 13px;
    font-weight: 400;
    color: rgba(242, 20, 47, 1);
    line-height: 21px;
    margin-left: 50px;
  }
}
</style>